import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainAttendanceComponent } from './main-attendance.component';


const routes: Routes = [
  {
    path: '',
    component: MainAttendanceComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainAttendanceRoutingModule { }
